import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Col, Row, Modal, DatePicker } from "antd";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnCard from "../common/adnCard/AdnCard";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import { dateFormat } from "../common/GeneralConfigurations";

const FollowUpEventTypeListForm = ({
  title,
  eventTypes,
  loading,
  columns,
  currentPage,
  totalRecords,
  handleTableChanges,
  handleChangePage,
  statusOptions,
  isForOptions,
  yesOrNoOptions,
  academicHandleChange,
  firstYearHandleChange,
  statusHandleChange,
  showDeactivateModal,
  handleDeactivate,
  handleBackDeactivateModal,
}) => {
  const { t } = useTranslation();

  const [showError, setShowError] = useState(false);
  const [endDate, setEndDate] = useState(null);

  const disabledDate = (current) => {
    // accepts dates only from today on
    return current && current < moment().startOf("day");
  };

  const validateErrors = () => {
    if (endDate === null) {
      setShowError(true);
    } else {
      setShowError(false);
      handleDeactivate(endDate);
    }
  };

  const onChange = (date, dateString) => {
    setEndDate(dateString);
  };

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 8 }}
            lg={{ span: 8 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              handleChange={academicHandleChange}
              placeholder={t("followUpEventType.form.placeholders.isFor")}
              allowClear={true}
              options={isForOptions}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 8 }}
            lg={{ span: 8 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              handleChange={firstYearHandleChange}
              placeholder={t(
                "followUpEventType.form.placeholders.firstYearOnly"
              )}
              allowClear={true}
              options={yesOrNoOptions}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 8 }}
            lg={{ span: 8 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              handleChange={statusHandleChange}
              placeholder={t("followUpEventType.form.placeholders.status")}
              allowClear={true}
              defaultValue={false}
              options={statusOptions}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={eventTypes}
              currentPage={currentPage}
              totalRecords={totalRecords}
              handleChange={handleTableChanges}
              handleChangePage={handleChangePage}
            />
          </Col>
        </Row>
      </AdnCard>

      <Modal
        title={t("followUpEventType.form.modals.deactivatingEvent")}
        open={showDeactivateModal}
        onOk={validateErrors}
        okText={t("followUpEventType.form.buttons.deactivate")}
        okButtonProps={{
          style: { backgroundColor: "red", borderColor: "red" },
        }}
        cancelText={t("followUpEventType.form.buttons.back")}
        onCancel={handleBackDeactivateModal}
      >
        <span style={{ color: "red" }}>*</span>
        <span> {t("followUpEventType.form.labels.endDate")} </span>
        <div>
          <DatePicker
            placeholder={t("followUpEventType.form.placeholders.selectEndDate")}
            onChange={onChange}
            disabledDate={disabledDate}
            rules={{
              required: true,
              message: t("followUpEventType.form.validation.endDateRequired"),
            }}
            format={dateFormat}
          />
        </div>
        {showError && (
          <div>
            <span style={{ color: "red" }}>
              {t("followUpEventType.form.validation.selectEndDate")}
            </span>
          </div>
        )}
      </Modal>
    </>
  );
};

export default FollowUpEventTypeListForm;
